(function () {

  var DF_SEARCH_DEBOUNCE = 180;


  function initDFSearch() {

    var root = document.querySelector('[data-df-search]');

    if (!root) return;


    var input =
      root.querySelector('[data-df-search-input]');

    var form =
      root.querySelector('[data-df-search-form]');

    var clear =
      root.querySelector('[data-df-search-clear]');

    var initial =
      root.querySelector('[data-df-search-initial]');

    var automatic =
      root.querySelector('[data-df-search-automatic]');

    var results =
      root.querySelector('[data-df-search-results]');

    var predictiveUrl =
      root.dataset.predictiveUrl;

    var searchUrl =
      root.dataset.searchUrl;

    var rootUrl =
      root.dataset.rootUrl || '/';


    var automaticLoaded = false;
    var automaticLoading = false;

    var debounceTimer = null;

    var searchAbortController = null;

    var lastQuery = '';


    /* =====================================================
       HELPERS
    ===================================================== */


    function normalizedRoot() {

      return rootUrl.endsWith('/')
        ? rootUrl
        : rootUrl + '/';

    }


    function debounceSearch() {

      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(
        handleQuery,
        DF_SEARCH_DEBOUNCE
      );

    }


    function setLoading() {

      results.innerHTML =
        '<div class="df-search__loading">' +
          '<span class="df-search__spinner"></span>' +
          'Buscando...' +
        '</div>';

      results.hidden = false;
      initial.hidden = true;

    }


    function showInitial() {

      results.hidden = true;
      results.innerHTML = '';

      initial.hidden = false;

    }


    /* =====================================================
       OPEN / CLOSE
    ===================================================== */


    function openSearch() {

      root.classList.add('is-open');

      root.setAttribute(
        'aria-hidden',
        'false'
      );

      document.documentElement.classList.add(
        'df-search-lock'
      );

      loadAutomaticState();


      window.setTimeout(function () {

        if (input) {
          input.focus();
        }

      }, 40);

    }


    function closeSearch() {

      root.classList.remove('is-open');

      root.setAttribute(
        'aria-hidden',
        'true'
      );

      document.documentElement.classList.remove(
        'df-search-lock'
      );

    }


    /* =====================================================
       AUTOMATIC INITIAL STATE
    ===================================================== */


    function loadAutomaticState() {

      if (
        automaticLoaded ||
        automaticLoading ||
        !automatic
      ) {
        return;
      }


      automaticLoading = true;


      var url =
        normalizedRoot() +
        'collections/all' +
        '?sort_by=best-selling' +
        '&section_id=df-search-empty-state';


      fetch(url, {
        credentials: 'same-origin'
      })

        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'DF Search automatic state: ' +
              response.status
            );
          }

          return response.text();

        })

        .then(function (html) {

          var documentFragment =
            new DOMParser()
              .parseFromString(
                html,
                'text/html'
              );


          var state =
            documentFragment.querySelector(
              '[data-df-auto-state]'
            );


          if (!state) {

            throw new Error(
              'DF automatic state not found'
            );

          }


          automatic.innerHTML =
            state.innerHTML;


          removePinnedDuplicates();


          automaticLoaded = true;

        })

        .catch(function (error) {

          console.warn(error);

          automatic.innerHTML = '';

        })

        .finally(function () {

          automaticLoading = false;

        });

    }


    function removePinnedDuplicates() {

      var pinnedHandles =
        Array.from(
          root.querySelectorAll(
            '[data-df-pinned-products] [data-product-handle]'
          )
        )
        .map(function (product) {

          return product.dataset.productHandle;

        });


      if (!pinnedHandles.length) {
        return;
      }


      root
        .querySelectorAll(
          '.df-search-product--automatic[data-product-handle]'
        )
        .forEach(function (product) {

          if (
            pinnedHandles.indexOf(
              product.dataset.productHandle
            ) !== -1
          ) {

            product.remove();

          }

        });

    }


    /* =====================================================
       PREDICTIVE SEARCH
    ===================================================== */


    function handleQuery() {

      var query =
        input.value.trim();


      clear.hidden =
        query.length === 0;


      if (!query.length) {

        lastQuery = '';

        if (searchAbortController) {
          searchAbortController.abort();
        }

        showInitial();

        return;

      }


      if (query === lastQuery) {
        return;
      }


      lastQuery = query;

      searchProducts(query, true);

    }


    function searchProducts(
      query,
      allowFallback
    ) {

      if (searchAbortController) {
        searchAbortController.abort();
      }


      searchAbortController =
        new AbortController();


      setLoading();


      var params =
        '?q=' +
        encodeURIComponent(query) +

        '&resources[type]=' +
        encodeURIComponent(
          'product,collection,article,page'
        ) +

        '&resources[limit]=8' +

        '&resources[limit_scope]=each' +

        '&resources[options][unavailable_products]=last' +

        '&section_id=df-predictive-search';


      fetch(
        predictiveUrl + params,
        {
          signal:
            searchAbortController.signal,

          credentials:
            'same-origin'
        }
      )

        .then(function (response) {

          if (!response.ok) {

            throw new Error(
              'Predictive search: ' +
              response.status
            );

          }

          return response.text();

        })

        .then(function (html) {

          var parsed =
            new DOMParser()
              .parseFromString(
                html,
                'text/html'
              );


          var content =
            parsed.querySelector(
              '[data-df-predictive-content]'
            );


          if (!content) {

            throw new Error(
              'Predictive content not found'
            );

          }


          var noProducts =
            content.dataset.dfNoProducts ===
            'true';


          if (
            noProducts &&
            allowFallback
          ) {

            findAlternativeQuery(
              query,
              content
            );

            return;

          }


          renderResults(
            content.innerHTML
          );

        })

        .catch(function (error) {

          if (
            error.name ===
            'AbortError'
          ) {
            return;
          }


          console.warn(error);


          results.innerHTML =
            '<div class="df-search__empty">' +
              '<strong>No hemos podido completar la búsqueda.</strong>' +
              '<p>Puedes pulsar Enter para ver todos los resultados.</p>' +
            '</div>';

        });

    }


    /* =====================================================
       SMART FALLBACK
    ===================================================== */


    function findAlternativeQuery(
      originalQuery,
      originalContent
    ) {

      var suggestionUrl =
        predictiveUrl +
        '.json' +

        '?q=' +
        encodeURIComponent(
          originalQuery
        ) +

        '&resources[type]=query' +

        '&resources[limit]=1';


      fetch(
        suggestionUrl,
        {
          credentials:
            'same-origin'
        }
      )

        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'Query suggestion failed'
            );
          }

          return response.json();

        })

        .then(function (data) {

          var suggestions =
            data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.queries;


          if (
            !suggestions ||
            !suggestions.length
          ) {

            renderResults(
              originalContent.innerHTML
            );

            return;

          }


          var suggested =
            suggestions[0].text;


          if (
            !suggested ||
            suggested.toLowerCase() ===
            originalQuery.toLowerCase()
          ) {

            renderResults(
              originalContent.innerHTML
            );

            return;

          }


          searchAlternativeProducts(
            originalQuery,
            suggested
          );

        })

        .catch(function () {

          renderResults(
            originalContent.innerHTML
          );

        });

    }


    function searchAlternativeProducts(
      originalQuery,
      suggestedQuery
    ) {

      var params =
        '?q=' +
        encodeURIComponent(
          suggestedQuery
        ) +

        '&resources[type]=' +
        encodeURIComponent(
          'product,collection,article,page'
        ) +

        '&resources[limit]=8' +

        '&resources[limit_scope]=each' +

        '&resources[options][unavailable_products]=last' +

        '&section_id=df-predictive-search';


      fetch(
        predictiveUrl + params,
        {
          credentials:
            'same-origin'
        }
      )

        .then(function (response) {

          return response.text();

        })

        .then(function (html) {

          var parsed =
            new DOMParser()
              .parseFromString(
                html,
                'text/html'
              );


          var content =
            parsed.querySelector(
              '[data-df-predictive-content]'
            );


          if (!content) return;


          var notice =
            '<div class="df-search__correction">' +
              '<span>No encontramos exactamente ' +
                '“' +
                escapeHtml(originalQuery) +
                '”.</span>' +
              '<strong> Te mostramos resultados para ' +
                '“' +
                escapeHtml(suggestedQuery) +
                '”.</strong>' +
            '</div>';


          renderResults(
            notice +
            content.innerHTML
          );

        });

    }


    function renderResults(html) {

      initial.hidden = true;

      results.innerHTML = html;

      results.hidden = false;

    }


    function escapeHtml(text) {

      var element =
        document.createElement('div');

      element.textContent = text;

      return element.innerHTML;

    }


    /* =====================================================
       EVENTS
    ===================================================== */


    input.addEventListener(
      'input',
      debounceSearch
    );


    clear.addEventListener(
      'click',
      function () {

        input.value = '';

        clear.hidden = true;

        lastQuery = '';

        showInitial();

        input.focus();

      }
    );


    form.addEventListener(
      'submit',
      function (event) {

        if (!input.value.trim()) {

          event.preventDefault();

          input.focus();

        }

      }
    );


    root
      .querySelectorAll(
        '[data-df-search-close]'
      )
      .forEach(function (button) {

        button.addEventListener(
          'click',
          closeSearch
        );

      });


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          root.classList.contains(
            'is-open'
          )
        ) {

          closeSearch();

        }

      }
    );


    document.addEventListener(
      'click',
      function (event) {

        var trigger =
          event.target.closest(
            '[data-df-search-open]'
          );


        if (!trigger) return;


        event.preventDefault();

        openSearch();

      }
    );


    window.DFSearch = {
      open: openSearch,
      close: closeSearch
    };

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initDFSearch,
      { once: true }
    );

  } else {

    initDFSearch();

  }

})();